const toKebabCase = (string)=>string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
export default toKebabCase;

//# sourceMappingURL=toKebabCase.js.map